import { useMemo } from 'react';

export function useMasonryLayout({
  items,
  columns,
  gap,
  keyOf,
  heightsById,
  estimateHeight,
  defaultEstimate = 240,
  layoutVersion = 0,
}) {
  const safeColumns = Math.max(1, columns || 1);

  return useMemo(() => {
    const colHeights = new Array(safeColumns).fill(0);

    const colWidthExpr = `calc((100% - ${(safeColumns - 1) * gap}px) / ${safeColumns})`;

    const positions = items.map((item) => {
      const id = keyOf(item);

      let col = 0;
      for (let i = 1; i < safeColumns; i++) {
        if (colHeights[i] < colHeights[col]) col = i;
      }

      const measured = heightsById.get(id);
      const estimated = typeof estimateHeight === 'function' ? Math.max(1, estimateHeight(item)) : defaultEstimate;

      const h = measured != null && measured > 0 ? measured : estimated;

      const top = colHeights[col];
      colHeights[col] = colHeights[col] + h + gap;

      const leftExpr = `calc(${col} * (${colWidthExpr} + ${gap}px))`;

      return {
        id,
        item,
        top,
        leftExpr,
        widthExpr: colWidthExpr,
        usedHeight: h,
        hasMeasured: measured != null && measured > 0,
        col,
      };
    });

    const contentHeight = Math.max(0, ...colHeights) - gap;

    return {
      positions,
      contentHeight: Math.max(0, contentHeight),
      colWidthExpr,
      columns: safeColumns,
    };
  }, [items, safeColumns, gap, keyOf, heightsById, estimateHeight, defaultEstimate, layoutVersion]);
}
